import { createApp, provide, h, defineAsyncComponent } from 'vue'

const SearchHeader = defineAsyncComponent(() => import('@/SearchHeader.vue'))
const MobileSearchHeader = defineAsyncComponent(() => import('@/MobileSearchHeader.vue'))
const MobilePlainHeader = defineAsyncComponent(() => import('@/MobilePlainHeader.vue'))
const HeroSearch = defineAsyncComponent(() => import('@/HeroSearch.vue'))
const Results = defineAsyncComponent(() => import('@/Results.vue'))
const DetailsForm = defineAsyncComponent(() => import('@/DetailsForm.vue'))
const DetailsMap = defineAsyncComponent(() => import('@/DetailsMap.vue'))
const DetailsCalendar = defineAsyncComponent(() => import('@/DetailsCalendar.vue'))
const DetailsCancellation = defineAsyncComponent(() => import('@/DetailsCancellation.vue'))
const MobilePopup = defineAsyncComponent(() => import('@/MobilePopup.vue'))
const MobileBooker = defineAsyncComponent(() => import('@/MobileBookTrigger.vue'))
const DetailsBookTrigger = defineAsyncComponent(() => import('@/DetailsBookTrigger.vue'))

const Apollo = () => import('@apollo/client/core')
import { DefaultApolloClient } from '@vue/apollo-composable'
import { createPinia } from 'pinia'
const Mq = () => import('vue3-mq')
const VueSocialSharing = () => import('vue-social-sharing')
const Vue3TouchEvents = () => import('vue3-touch-events')

// instantiate pinia (central data point)
const pinia = createPinia()

Promise.all([Apollo(), Mq(), VueSocialSharing(), Vue3TouchEvents()]).then(all => {
  const InMemoryCache = all[0].InMemoryCache;
  const ApolloClient = all[0].ApolloClient;
  const Vue3Mq = all[1].Vue3Mq;
  const VueSocialSharing = all[2].default
  const Vue3TouchEvents = all[3].default

  const cache = new InMemoryCache();
  const defaultClient = new ApolloClient({
    cache,
    uri: process.env.VUE_APP_API_CLIENT
  });

  const searchApp = createApp({
    setup () {
      provide(DefaultApolloClient, defaultClient)
    },
    render() {
      return h(SearchHeader)
    }
  })
  searchApp.use(pinia).use(Vue3Mq)
  searchApp.mount('#casiola_app_header_search_header')

  const mobileSearchApp = createApp({
    setup () {
      provide(DefaultApolloClient, defaultClient)
    },
    render() {
      return h(MobileSearchHeader)
    }
  })
  mobileSearchApp.use(pinia).use(Vue3TouchEvents).use(Vue3Mq)
  mobileSearchApp.mount('#casiola_app_header_mobile_search_header')

  const mobileHeaderApp = createApp({
    setup () {
    },
    render() {
      return h(MobilePlainHeader)
    }
  })
  mobileHeaderApp.use(Vue3Mq)
  mobileHeaderApp.mount('#casiola_app_header_mobile_plain_header')

    const heroSearchApp = createApp({
      setup () {
        provide(DefaultApolloClient, defaultClient)
      },
      render() {
        return h(HeroSearch)
      }
    })
    heroSearchApp.use(pinia).use(Vue3Mq)
    heroSearchApp.mount('#casiola_app_hero_search')

  const resultsApp = createApp({
      setup () {
        provide(DefaultApolloClient, defaultClient)
      },
      render() {
        return h(Results)
      }
  }).use(pinia).use(Vue3TouchEvents).use(Vue3Mq)
  resultsApp.mount('#casiola_app_results');

  const detailsFormApp = createApp({
      setup () {
        provide(DefaultApolloClient, defaultClient)
      },
      render() {
        return h(DetailsForm)
      }
  }).use(pinia).use(Vue3TouchEvents).use(Vue3Mq);
  detailsFormApp.mount('#casiola_app_details_form');

  const detailsMapApp = createApp({
    setup () {
      provide(DefaultApolloClient, defaultClient)
    },
    render() {
      return h(DetailsMap)
    }
  }).use(pinia).use(Vue3Mq)
  detailsMapApp.mount('#casiola_app_details_map');

  const detailsCalendarApp = createApp({
    setup () {
      provide(DefaultApolloClient, defaultClient)
    },
    render() {
      return h(DetailsCalendar)
    }
  }).use(pinia).use(Vue3Mq)
  detailsCalendarApp.mount('#casiola_app_details_calendar');

  // Promise.all([VueSocialSharing(), Vue3TouchEvents()]).then(events => {
  const mobilePopupApp = createApp({
    setup () {
      provide(DefaultApolloClient, defaultClient)
    },
    render() {
      return h(MobilePopup)
    }
  }).use(pinia).use(VueSocialSharing).use(Vue3TouchEvents).use(Vue3Mq)
  mobilePopupApp.mount('#casiola_app_mobile_popup');
  // })

  const mobileBookerApp = createApp(MobileBooker).use(pinia).use(Vue3Mq)
  mobileBookerApp.mount('#casiola_app_mbooker');

  const desktopBookerApp = createApp(DetailsBookTrigger).use(pinia).use(Vue3Mq)
  desktopBookerApp.mount('#casiola_app_header_desktop_sticky_booking');

  const detailsCancellationApp = createApp(DetailsCancellation).use(pinia).use(Vue3Mq)
  detailsCancellationApp.mount('#casiola_app_details_cancellation');

  const detailsCancellationApp2 = createApp(DetailsCancellation).use(pinia).use(Vue3Mq)
  detailsCancellationApp2.mount('#casiola_app_details_cancellation2');
})